import { func, node, shape } from 'prop-types';
import React from 'react';

import { SHAPE } from '../common';
import { Consumer as ConsumerReactor, Provider as ProviderReactor } from '../reactor/context';
import { ConsumerAmplitude, ProviderAmplitude } from './contextAmplitude';
import { ConsumerData, ProviderData } from './contextData';
import { ConsumerEvents, ProviderEvents } from './contextEvents';
import ConsumerL10N from './consumerL10N';

const Consumer = ({ children }) => (
  <ConsumerData>
    {data => (
      <ConsumerEvents>
        {events => (
          <ConsumerAmplitude>
            {amplitude => children({
              ...data, ...events, ...amplitude, ...ConsumerL10N(data ? data.dataSource : undefined),
            })}
          </ConsumerAmplitude>
        )}
      </ConsumerEvents>
    )}
  </ConsumerData>
);

Consumer.propTypes = {
  children: func.isRequired,
};

const Provider = ({
  children, session, store, ...events
}) => (
  <ProviderReactor session={session}>
    <ProviderData store={store}>
      <ProviderEvents {...events}>
        <ConsumerData>
          {({ dataSource }) => (
            <ConsumerReactor>
              { ({ logEvent }) => (
                <ProviderAmplitude logEvent={logEvent} story={dataSource}>
                  {children}
                </ProviderAmplitude>
              )}
            </ConsumerReactor>
          ) }
        </ConsumerData>
      </ProviderEvents>
    </ProviderData>
  </ProviderReactor>
);

Provider.propTypes = {
  children: node.isRequired,
  session: shape(SHAPE.SESSION),
  store: shape({}),
};

Provider.defaultProps = {
  session: undefined,
  store: undefined,
};

export {
  Consumer,
  Provider,
};
